<template>
  <i :class="classes" :aria-hidden="ariaHidden" @click="$emit('click', $event)">{{ name }}</i>
</template>

<script>
import DomContentLoadedMixin from 'vuemixins/dom_content_loaded_mixin'

export default {
  mixins: [DomContentLoadedMixin],
  props: {
    name: {
      type: String,
      required: true,
      validator: (name) => !!name
    },
    size: {
      type: String,
      required: false,
      default: 'normal',
      validator: (value) => ['small', 'normal'].includes(value),
    },
    ariaHidden: {
      type: String,
      required: false,
      default: 'true',
      validator: (value) => ['true', 'false'].includes(value),
    },
  },
  computed: {
    classes () {
      const classList = []
      if (this.isDomLoaded) {
        classList.push('immaterial-icons')
        if (this.size === 'small') {
          classList.push('immaterial-icons-18')
        }
      } else {
        classList.push('immaterial-placeholder')
        if (this.size === 'small') {
          classList.push('immaterial-placeholder-18')
        }
      }
      return classList
    }
  }
}
</script>

<style lang="scss" scoped>

@mixin immaterial-icon {
  font-family: 'immaterial';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;

  /* Enable Ligatures ================ */
  letter-spacing: 0;
  -webkit-font-feature-settings: "liga";
  -moz-font-feature-settings: "liga=1";
  -moz-font-feature-settings: "liga";
  -ms-font-feature-settings: "liga" 1;
  font-feature-settings: "liga";
  -webkit-font-variant-ligatures: discretionary-ligatures;
  font-variant-ligatures: discretionary-ligatures;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.immaterial-icons {
  @include immaterial-icon;
}

.immaterial-icons-18 {
  font-size: 18px;
}

.immaterial-placeholder {
  visibility: hidden;
  width: 24px;
  height: 24px;
  display: inline-block;
}

.immaterial-placeholder-18 {
  visibility: hidden;
  width: 18px;
  height: 18px;
  display: inline-block;
}

</style>
